import { render, staticRenderFns } from "./myResearchTask.vue?vue&type=template&id=4a52ee34&scoped=true&"
import script from "./myResearchTask.vue?vue&type=script&lang=js&"
export * from "./myResearchTask.vue?vue&type=script&lang=js&"
import style0 from "./myResearchTask.vue?vue&type=style&index=0&id=4a52ee34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52ee34",
  null
  
)

export default component.exports